import { render, staticRenderFns } from "./BusinessInformation.vue?vue&type=template&id=615335f2&"
import script from "./BusinessInformation.vue?vue&type=script&lang=js&"
export * from "./BusinessInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports